import React from "react";

import aboutImg from "../assets/images/logo.png";

function About() {
  return (
    <section className="about-section py-5" id="about">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 mb-5 mb-lg-0 align-self-center">
            <img
              src={aboutImg}
              alt=""
              className="img-fluid w-75 m-auto d-block"
            />
          </div>
          <div className="col-lg-7 mb-5 mb-lg-0 align-self-center">
            <h3 className="mb-3 text-uppercase fw-bold">About Us</h3>
            <p>
              Magmus Consulting emerges as a civil construction, Smart Property
              and Smart Security lead in Pakistan.
            </p>
            <p>
              We, as a team, assist clients in a variety of industries,
              commercial, residential and institutions projects. Our Company is
              reputable for providing the best solutions that enhance and boost
              the companies’ projects.
            </p>
            <p>
              Magmus’ professional team is always updated with industry trends.
              Our team plays a vital role in building a positive interaction
              between clients and the companies for better results. We deliver
              clients quick services and help to accomplish all the targets
              within a given timeline. We comprise highly skilled Technical
              Support Engineers and experienced staff that ensure the
              satisfaction of the clients.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
